import useQuery from '@shared/hooks/src/useQuery'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export default function useProvider(providerId, options = {}, config) {
  return useQuery({
    queryKey: QK.providers.id(providerId).details,
    queryFn: () => API.providers.id(providerId).details(config),
    enabled: Boolean(providerId),
    ...options,
  })
}
